import React, { createContext, useState } from "react";

const ModalContext: React.Context<any> = createContext<any>({});

export const ModalProvider = ({ children }: any) => {
  const [showUploadCV, setShowUploadCV] = useState<boolean>(false);

  const handleToggleModal = () => {
    setShowUploadCV(!showUploadCV);
  }
  return (
    <ModalContext.Provider value={{ showUploadCV, setShowUploadCV, handleToggleModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
